import { storage } from '../data/localStorage';

export const cloService = {
  // Get all CLOs (with team workspace support)
  async getCLOs(workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage
      return storage.getCLOs();
    } catch (error) {
      console.error('Error fetching CLOs:', error);
      // Fallback to localStorage
      return storage.getCLOs();
    }
  },

  // Add single CLO
  async addCLO(cloData, workspaceId, userId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      return storage.addCLO(cloData);
    } catch (error) {
      console.error('Error adding CLO:', error);
      // Fallback to localStorage only
      return storage.addCLO(cloData);
    }
  },

  // Update CLO
  async updateCLO(cloId, updatedData, workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      storage.updateCLO(cloId.toString(), updatedData);
      return null;
    } catch (error) {
      console.error('Error updating CLO:', error);
      // Fallback to localStorage only
      storage.updateCLO(cloId.toString(), updatedData);
      return null;
    }
  },

  // Delete CLO
  async deleteCLO(cloId, workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      storage.deleteCLO(cloId.toString());
      return true;
    } catch (error) {
      console.error('Error deleting CLO:', error);
      // Fallback to localStorage only
      storage.deleteCLO(cloId.toString());
      return false;
    }
  },

  // Get CLOs by course code
  async getCLOsByCourseCode(courseCode, workspaceId) {
    try {
      const allCLOs = await this.getCLOs(workspaceId);
      return allCLOs.filter(clo => clo.courseCode === courseCode);
    } catch (error) {
      console.error('Error fetching CLOs by course code:', error);
      return [];
    }
  }
};